export default __webpack_public_path__ + "static/media/ghabli.24a56777.svg";